
import {Component, input} from '@angular/core';
import {ICookie} from '@app/cookie-consent/models/cookie-consent.model';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonModule} from 'primeng/button';
import {CookieTableComponent} from '../cookie-table/cookie-table.component';

@Component({
  selector: 'app-cookie-type',
  imports: [CookieTableComponent, ButtonModule, TranslateModule],
  templateUrl: './cookie-type.component.html',
})
export class CookieTypeComponent {
  readonly title = input('');
  readonly cookies = input<ICookie[]>([]);
}
